var isMobile= window.outerWidth > 767 ? false: true;

function sameHeight(minWidth, cssClass) {


	if (jQuery(window).width() > minWidth) {
	
		var items = jQuery(cssClass), // grab all the slides
		heights = [], // array to store heights
		tallest; // tallest slide

		if (items.length) {
			function normalizeHeights() {
				items.each(function() {
					heights.push(jQuery(this).outerHeight()); // add each slide's
					// height
				}); // to the array

				tallest = Math.max.apply(null, heights); // find the largest
				// height

				items.each(function() {
					jQuery(this).css('min-height', tallest + 'px'); // set each
					// slide's
					// minimum
				}); // height to the largest
			}
			;

			normalizeHeights();
			jQuery(window).on('resize orientationchange', function() {
				tallest = 0, heights.length = 0; // reset the variables

				items.each(function() {
					jQuery(this).css('min-height', '0'); // reset each slide's height
				});

				normalizeHeights(); // run it again
			});
		}

	}

};

jQuery(document).ready(function() {
	
	jQuery(".click-hover-click").click(function() {
		jQuery( this).parent('.click-hover').toggleClass( "click-hover-active" )
		});
	sameHeight(300,'.loop-img-cointainer-same-height');
});